import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputDateComponent } from './input-date.component';
import { InputSelectModule } from '../input-select/input-select.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [InputDateComponent],
  imports: [
    CommonModule,
    InputSelectModule,
    InputFieldModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [InputDateComponent],
})
export class InputDateModule { }
